<p-toast></p-toast>
<p-card>
    <ng-template pTemplate="header">
        <h5 class="pdfs-15">{{'PASSWORD' | translate}}</h5>
    </ng-template>
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <h5 class="customfont1 mT-15 ">{{'NEW_PASSWORD' | translate}}</h5>
            <p-password placeholder="{{'PASSWORD' | translate}}" [(ngModel)]="password" [toggleMask]="true"
                [ngClass]="{'error-field': showError}">
                <!-- <ng-template pTemplate="footer">
                    <p-divider></p-divider>
                    <p class="p-mt-2">Sugerencia</p>
                    <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                        <li>Al menos una minúscula</li>
                        <li>Al menos una mayúscula</li>
                        <li>Al menos un número</li>
                        <li>Minimo 8 caracteres</li>
                    </ul>
                </ng-template> -->
            </p-password>
        </div>
        <div class="p-col-12 p-md-6">
            <h5 class="customfont1 mT-15">{{'CONFIRM_PASSWORD' | translate}}</h5>
            <p-password [(ngModel)]="confirmPassword" [feedback]="false" placeholder="{{'PASSWORD' | translate}}" [toggleMask]="true"
                [ngClass]="{'error-field': showError}"></p-password>

        </div>

    </div>
    <div *ngIf="showError" class="error-message">
        {{ mensajeError }}
    </div>
    <ng-template pTemplate="footer">
        <div class="row">
            <button [disabled]="!(password && confirmPassword)" pButton pRipple (click)="updatePassword()" type="button"
                icon="pi pi-pencil" label="{{'CHANGE_PASSWORD' | translate}}" class="p-button-raised p-button-success fR"></button>
        </div>
    </ng-template>
    <br />
    <br />
</p-card>